import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Close — dismiss sheets, dialogs, banners. */
export function CloseIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </PortalIcon>
  );
}
